import {
  FormStep,
  MultiSelectDropdown,
  Table,
  Row,
  CardSubHeader,
  StatusTable,
  LinkButton,
  CardSectionHeader,
  RemoveableTag,
  Toast,
  Loader,
  TextInput, 
  CardLabel, 
  SubmitBar,
  CardHeader
} from "@egovernments/digit-ui-react-components";
import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Checkbox, FormControlLabel } from "@mui/material";
import { stringReplaceAll } from "../utils";

const parseNumber = value => {
  const number = parseFloat(value);
  return isNaN(number) ? 0 : number;
};

const ScrutinyDetails = ({ onSelect, userType, formData, config }) => {
  const { t } = useTranslation();
  const [subOccupancy, setsubOccupancy] = useState([]);
  const [subOccupancyObject, setsubOccupancyObject] = useState(formData?.subOccupancy || formData?.landInfo?.unit || {});
  let user = Digit.UserService.getUser();
  let validation = {};
  const tenantId = user?.info?.permanentCity || Digit.ULBService.getCurrentTenantId();
  const checkingFlow = formData?.uiFlow?.flow;
  const setBacksObj = formData?.data?.edcrDetails?.planDetail?.blocks?.[0]?.setBacks
  const applicationFlow = Digit?.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
  const isUdFlow = applicationFlow === 'UD';
  const [showToast, setShowToast] = useState(null);

  const [monument, setMonument] = useState(formData?.[config.key]?.checklistData?.isAsiMonumnet || { code: 'NO' });
  const [tree, setTree] = useState(formData?.[config.key]?.checklistData?.isTreeNear || { code: 'NO' });
  const [highway, setHighway] = useState(formData?.[config.key]?.checklistData?.isHighwayNear || { code: 'NO' });
  const [drainage, setDrainage] = useState(formData?.[config.key]?.checklistData?.isAbuttingDrainage || { code: 'NO' });
  const [pipeline, setPipeline] = useState(formData?.[config.key]?.checklistData?.isCrossingPipeline || { code: 'NO' });
  const [solar, setSolar] = useState(formData?.[config.key]?.checklistData?.isSolarInstalled || { code: 'NO' });
  const [barrierfee, setBarrierFee] = useState(formData?.[config.key]?.checklistData?.isBarrierFeeforDisabled || { code: 'NO' });
  const [valley, setValley] = useState(formData?.[config.key]?.checklistData?.isAbovetheValley || { code: 'NO' });
  const [sliding, setSliding] = useState(formData?.[config.key]?.checklistData?.isNearSinkingOrSliding || { code: 'NO' });
  const [rainwater, setRainwater] = useState(formData?.[config.key]?.checklistData?.isProvisionforrainwater || { code: 'NO' });
  const [airport, setAirport] = useState(formData?.[config.key]?.checklistData?.isAAIPermissioned || { code: 'NO' });

  const [dwelling, setDwelling] = useState(formData?.[config.key]?.checklistData?.noOfDwellingUnit || 0)
  const [muckToBeDisposed, setMuckToBeDisposed] = useState(formData?.[config.key]?.checklistData?.muckToBeDisposed || 0);
  const [setBacks, setSetbacks] = useState({
    front: setBacksObj?.[0]?.frontYard?.minimumDistance || "", 
    rear: setBacksObj?.[0]?.rearYard?.minimumDistance || "",
    left: setBacksObj?.[0]?.sideYard1?.minimumDistance || "",
    right: setBacksObj?.[0]?.sideYard2?.minimumDistance || ""
  })
  console.log(setBacksObj,  "scrutinydetailspageformdata");

  const labelStyle = {
    fontWeight: '30px',
    fontSize: '1rem', 
  };
  const stateCode = Digit.ULBService.getStateId();
  const { isMdmsLoading, data: mdmsData } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["SubOccupancyType"]);
  const { data, isLoading, refetch } = Digit.Hooks.obps.useScrutinyDetails(tenantId, formData?.data?.scrutinyNumber, {
    enabled: true,
  });


  function getFloorData(block) {
    let floors = [];
    block?.building?.floors?.map((ob) => {
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${ob.occupancies?.[0]?.type}`),
        BuildupArea: ob.occupancies?.[0]?.builtUpArea,
        FloorArea: ob.occupancies?.[0]?.floorArea || 0,
        CarpetArea: ob.occupancies?.[0]?.CarpetArea || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`),
      });
    });
    return floors;
  }

  function getsuboptions() {
    let suboccoption = [];
    // data &&
      // data?.planDetail?.mdmsMasterData?.SubOccupancyType?.map((ob) => {
        mdmsData?.BPA?.SubOccupancyType?.map((ob) => {
        suboccoption.push({ code: ob.code, name: ob.name, i18nKey: `BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(ob?.code?.toUpperCase(), "-", "_")}` });
      });
    return Digit.Utils.locale.sortDropdownNames(suboccoption,'i18nKey',t);
  }

  const ActionButton = ({ label, jumpTo }) => {
    const { t } = useTranslation();
    const history = useHistory();
    function routeTo() {
      location.href = jumpTo;
    }
    return <LinkButton label={t(label)} onClick={routeTo} />;
  };

  const tableHeader = [
    {
      name: "BPA_TABLE_COL_FLOOR",
      id: "Floor",
    },
    {
      name: "BPA_TABLE_COL_LEVEL",
      id: "Level",
    },
    {
      name: "BPA_TABLE_COL_OCCUPANCY",
      id: "Occupancy",
    },
    {
      name: "BPA_TABLE_COL_BUILDUPAREA",
      id: "BuildupArea",
    },
    {
      name: "BPA_TABLE_COL_FLOORAREA",
      id: "FloorArea",
    },
    {
      name: "BPA_TABLE_COL_CARPETAREA",
      id: "CarpetArea",
    },
  ];
  const selectOccupancy = (e, data, num) => {
    let blocks = subOccupancyObject;
    let newSubOccupancy = [];
    e &&
      e?.map((ob) => {
        newSubOccupancy.push(ob?.[1]);
      });
    blocks[`Block_${num}`] = newSubOccupancy;
    setsubOccupancy(newSubOccupancy);
    setsubOccupancyObject(blocks);
  };

  const onRemove = (index, key, num) => {
    let afterRemove = subOccupancyObject[`Block_${num}`].filter((value, i) => {
      return i !== index;
    });
    setsubOccupancy(afterRemove);
    let temp = subOccupancyObject;
    temp[`Block_${num}`] = afterRemove;
    setsubOccupancyObject(temp);
  };

  const accessData = (plot) => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };

  const closeToast = () => {
    setShowToast(null);
  };

  const tableColumns = useMemo(() => {
    return tableHeader?.map((ob) => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id,
      //symbol: plot?.symbol,
      //sortType: sortRows,
    }));
  });

  const onSkip = () => onSelect();

  const goNext = () => {
    if (checkingFlow === "OCBPA") {
      if (!formData?.id) {
        let payload = {};
        payload.edcrNumber = formData?.edcrNumber?.edcrNumber ? formData?.edcrNumber?.edcrNumber : formData?.data?.scrutinyNumber?.edcrNumber;
        payload.riskType = formData?.data?.riskType;
        payload.applicationType = formData?.data?.applicationType;
        payload.serviceType = formData?.data?.serviceType;

        const userInfo = Digit.UserService.getUser();
        const accountId = userInfo?.info?.uuid;
        payload.tenantId = formData?.data?.bpaData?.bpaApprovalResponse?.[0]?.landInfo?.tenantId;
        payload.workflow = { action: "INITIATE", assignes : [userInfo?.info?.uuid] };
        payload.accountId = accountId;
        payload.documents = null;

        // Additonal details
        payload.additionalDetails = {};
        if (formData?.data?.holdingNumber) payload.additionalDetails.holdingNo = formData?.data?.holdingNumber;
        if (formData?.data?.registrationDetails) payload.additionalDetails.registrationDetails = formData?.data?.registrationDetails;
        if (formData?.data?.applicationType) payload.additionalDetails.applicationType = formData?.data?.applicationType;
        if (formData?.data?.serviceType) payload.additionalDetails.serviceType = formData?.data?.serviceType;

        //For LandInfo
        payload.landInfo = formData?.data?.bpaData?.bpaApprovalResponse?.[0].landInfo || {};

        let nameOfAchitect = sessionStorage.getItem("BPA_ARCHITECT_NAME");
        let parsedArchitectName = nameOfAchitect ? JSON.parse(nameOfAchitect) : "ARCHITECT";
        payload.additionalDetails.typeOfArchitect = parsedArchitectName;
        // create BPA call
        Digit.OBPSService.create({ BPA: payload }, tenantId)
          .then((result, err) => {
            if (result?.BPA?.length > 0) {
              result.BPA[0].data = formData.data;
              result.BPA[0].uiFlow = formData?.uiFlow;
              onSelect("", result.BPA[0], "", true);
            }
          })
          .catch((e) => {
            setShowToast({ key: "true", message: e?.response?.data?.Errors[0]?.message || null });
          });
      } else {
        onSelect("", formData, "", true);
      }
    } else {
      let ChecklistaData = { 
        setbackfront: setBacks?.front || "", 
        setbackrear : setBacks?.rear || "", 
        setbackleft: setBacks?.left || "", 
        setbackright: setBacks.right || "",

        isAsiMonumnet: monument,
        isTreeNear: tree,
        isHighwayNear: highway,
        isAbuttingDrainage: drainage,
        isCrossingPipeline: pipeline,
        isSolarInstalled: solar,
        isBarrierFeeforDisabled: barrierfee,
        isAbovetheValley: valley,
        isNearSinkingOrSliding: sliding,
        isProvisionforrainwater: rainwater,
        isAAIPermissioned: airport,

        noOfDwellingUnit: parseNumber(dwelling),
        ...(isUdFlow && {muckToBeDisposed: parseNumber(muckToBeDisposed)}),
      }
      subOccupancyObject.checklistData = ChecklistaData
      onSelect(config.key, subOccupancyObject);
    }
  };

  const clearall = (num) => {
    let res = [];
    let temp = subOccupancyObject;
    temp[`Block_${num}`] = res;
    setsubOccupancy(res);
    setsubOccupancyObject(temp);
  };

  function getSubOccupancyValues(index) {
    let values = formData?.data?.bpaData?.bpaApprovalResponse?.[0]?.landInfo?.unit;
    let returnValue = "";
    if (values?.length > 0) {
      let splitArray = values[index]?.usageCategory?.split(",");
      if (splitArray?.length) {
        const returnValueArray = splitArray?.map((data) =>
          data ? `${t(`BPA_SUBOCCUPANCYTYPE_${stringReplaceAll(data?.toUpperCase(), "-", "_")}`)}` : "NA"
        );
        returnValue = returnValueArray.join(", ");
      }
    }
    return returnValue ? returnValue : "NA";
  }

  if (isMdmsLoading || isLoading) return <Loader />
  const cardLabelStyle = {
    fontWeight: 600
  }; 

  return (
    <React.Fragment>
      <FormStep t={t} 
        onSelect={goNext}
        onSkip={onSkip}
        cardStyle={{boxShadow: 'none', padding: 0, border: 0}}
      >
          <StatusTable style={{ border: "none",marginLeft:"13px" }}>
          <Row
            className="border-none"
            style={{ border: "none" }}
            label={checkingFlow === "OCBPA" ? t("BPA_OC_EDCR_NO_LABEL") : t("BPA_EDCR_NO_LABEL")}
            text={data?.edcrNumber}
          ></Row>
          <Row
            className="border-none"
            label={t("BPA_UPLOADED_PLAN_DIAGRAM")}
            text={<ActionButton label={t("BPA_UPLOADED_PLAN_DXF")} jumpTo={data?.updatedDxfFile} />}
          ></Row>
          <Row
            className="border-none"
            label={t("BPA_SCRUNTINY_REPORT_OUTPUT")}
            text={<ActionButton label={t("BPA_SCRUTINY_REPORT_PDF")} jumpTo={data?.planReport} />}
          ></Row>
        </StatusTable>
        <hr style={{ color: "#cccccc", backgroundColor: "#cccccc", height: "2px", marginTop: "20px", marginBottom: "20px" }} />
        <CardSubHeader style={{ fontSize: "20px"}}>
          {checkingFlow === "OCBPA" ? t("BPA_ACTUAL_BUILDING_EXTRACT_HEADER") : t("BPA_BUILDING_EXTRACT_HEADER")}
        </CardSubHeader>
        <StatusTable style={{ border: "none",marginLeft:"13px" }}>
          <Row
            className="border-none"
            label={t("BPA_TOTAL_BUILT_UP_AREA_HEADER")}
            text={
              data?.planDetail?.blocks?.[0]?.building?.totalBuitUpArea
                ? `${data?.planDetail?.blocks?.[0]?.building?.totalBuitUpArea} ${t("BPA_SQ_MTRS_LABEL")}`
                : t("NA")
            }
          ></Row>
          <Row
            className="border-none"
            label={t("BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL")}
            text={data?.planDetail?.blocks?.[0]?.building?.totalFloors}
          ></Row>
          <Row
            className="border-none"
            label={t("BPA_HEIGHT_FROM_GROUND_LEVEL_FROM_MUMTY")}
            text={
              data?.planDetail?.blocks?.[0]?.building?.declaredBuildingHeight
                ? `${data?.planDetail?.blocks?.[0]?.building?.declaredBuildingHeight} ${t("BPA_MTRS_LABEL")}`
                : t("NA")
            }
          ></Row>
        </StatusTable>
        <hr style={{ color: "#cccccc", backgroundColor: "#cccccc", height: "2px", marginTop: "20px", marginBottom: "20px" }} />
        <CardSubHeader style={{fontSize: "20px"}}>{t("BPA_OCC_SUBOCC_HEADER")}</CardSubHeader>
        {data?.planDetail?.blocks?.map((block, index) => (
          <div key={index}>
            <CardSubHeader style={{ fontSize: "20px"}}>
              {t("BPA_BLOCK_SUBHEADER")} {index + 1}
            </CardSubHeader>
            <div style={{margin:"0px 0px 0px 13px"}}>
            {!(checkingFlow === "OCBPA") ? (
              <CardSectionHeader style={{ fontWeight: "bold"}} className="card-label-smaller">
                {t("BPA_SUB_OCCUPANCY_LABEL")}
              </CardSectionHeader>
            ) : null}
            {!(checkingFlow === "OCBPA") ? (
              <MultiSelectDropdown
                BlockNumber={block.number}
                className="form-field"
                isMandatory={true}
                defaultUnit="Selected"
                selected={subOccupancyObject[`Block_${block.number}`]}
                options={getsuboptions()}
                onSelect={(e) => selectOccupancy(e, data, block.number)}
                isOBPSMultiple={true}
                optionsKey="i18nKey"
                ServerStyle={{ width: "100%", overflowX: "hidden"}}
                t={t}
              />
            ) : null}
            {!(checkingFlow === "OCBPA") ? (
              <div className="tag-container">
                {subOccupancyObject[`Block_${block.number}`] &&
                  subOccupancyObject[`Block_${block.number}`].length > 0 &&
                  subOccupancyObject[`Block_${block.number}`]?.map((value, index) => (
                    <RemoveableTag key={index} text={`${t(value["i18nKey"])}`} onClick={() => onRemove(index, value, block.number)} />
                  ))}
              </div>
            ) : null}
            {!(checkingFlow === "OCBPA")
              ? subOccupancyObject[`Block_${block.number}`] &&
                subOccupancyObject[`Block_${block.number}`].length > 0 && (
                  <LinkButton style={{ textAlign: "left" }} label={"Clear All"} onClick={() => clearall(block.number)} />
                )
              : null}
            <div style={{ marginTop: "20px" }}>
              {checkingFlow === "OCBPA" ? (
                <StatusTable>
                  <Row className="border-none" label={`${t("BPA_SUB_OCCUPANCY_LABEL")}`} text={getSubOccupancyValues(index)}></Row>
                </StatusTable>
              ) : null}
              </div>
              <div style={{ overflowX: "scroll" }}>
                <Table
                  className="customTable table-fixed-first-column table-border-style"
                  t={t}
                  disableSort={false}
                  autoSort={true}
                  manualPagination={false}
                  isPaginationRequired={false}
                  initSortId="S N "
                  data={getFloorData(block)}
                  columns={tableColumns}
                  getCellProps={(cellInfo) => {
                    return {
                      style: {},
                    };
                  }}
                />
              </div>
            </div>
          </div>
        ))}
        <hr style={{ color: "#cccccc", backgroundColor: "#cccccc", height: "2px", marginTop: "20px", marginBottom: "20px" }} />
        <div>
        <CardSubHeader style={{ fontSize: "20px",textAlign:"left"}}>{t("BPA_APP_DETAILS_DEMOLITION_DETAILS_LABEL")}</CardSubHeader>
        <StatusTable style={{ border: "none" ,marginLeft:"13px"}}>
          <Row 
            label={t("BPA_APPLICATION_DEMOLITION_AREA_LABEL")}
            text={
              data?.planDetail?.planInformation?.demolitionArea
                ? `${data?.planDetail?.planInformation?.demolitionArea} ${t("BPA_SQ_MTRS_LABEL")}`
                : t("CS_NA")
            }
          ></Row>
        </StatusTable>
        </div>
        <div style={{margin:"0px 0px 0px 13px"}}>
        <CardLabel style={{fontWeight:"bold"}}>{`${t("BPA_APPLICATION_SETBACKS_INFORMATION")}`}</CardLabel>
        <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_SETBACLS_TYPE_FRONT_LABEL")}`}</CardLabel>
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="front"
              placeholder={"FRONT"}
              value={setBacks.front}
              onChange={(e) => setSetbacks({...setBacks, front: e.target.value})}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_SETBACKS_TYPE_REAR_LABEL")}`}</CardLabel>
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="rear"
              placeholder={"REAR"}
              value={setBacks.rear}
              onChange={(e) => setSetbacks({...setBacks, rear: e.target.value})}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_SETBACKS_TYPE_LEFT_LABEL")}`}</CardLabel>
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              placeholder={"LEFT"}
              name="left"
              value={setBacks.left}
              onChange={(e) => setSetbacks({...setBacks, left: e.target.value})}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          <CardLabel variant="h6" style={labelStyle}>{`${t("BPA_SETBACKS_TYPE_RIGHT_LABEL")}`}</CardLabel>
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="right"
              placeholder={"RIGHT"}
              value={setBacks.right}
              onChange={(e) => setSetbacks({...setBacks, right: e.target.value})}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
            </div>
            <div style={{marginLeft:"13px"}}>
          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_PROPOSED_PLAN_IS_LOCATED_NEAR_ASI_MONUMENT")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={monument.code === 'YES'}
                onChange={(e) => setMonument(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {monument.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="monument.name"
              value={monument.name}
              onChange={(e) => setMonument(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_TREES_STANDING_NEAR_PLOT")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={tree.code === 'YES'}
                onChange={(e) => setTree(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {tree.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="tree.name"
              value={tree.name}
              onChange={(e) => setTree(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_PLOT_ABUTTING_NATIONAL_HIGHWAY/STATE")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={highway.code === 'YES'}
                onChange={(e) => setHighway(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {highway.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="highway.name"
              value={highway.name}
              onChange={(e) => setHighway(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_PLOT_ABUTTING_NATURAL_DRAINAGE")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={drainage.code === 'YES'}
                onChange={(e) => setDrainage(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {drainage.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="drainage.name"
              value={drainage.name}
              onChange={(e) => setDrainage(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_PIPELINE_CROSSING_THE_PLOT")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={pipeline.code === 'YES'}
                onChange={(e) => setPipeline(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {pipeline.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="pipeline.name"
              value={pipeline.name}
              onChange={(e) => setPipeline(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_PROVISION_OF_SOLAR_PASSIVE_BUILDING")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={solar.code === 'YES'}
                onChange={(e) => setSolar(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {solar.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="solar.name"
              value={solar.name}
              onChange={(e) => setSolar(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_PROVISIONS_OF_BARRIER_FEE_FOR_PERSONS_WITH_DISABILITY")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={barrierfee.code === 'YES'}
                onChange={(e) => setBarrierFee(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {barrierfee.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="barrierfee.name"
              value={barrierfee.name}
              onChange={(e) => setBarrierFee(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_PLAN_IS_ABOVE_THE_ROAD_ON_VALLEY_SIDE")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={valley.code === 'YES'}
                onChange={(e) => setValley(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {valley.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="valley.name"
              value={valley.name}
              onChange={(e) => setValley(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_PLAN_IS_LOCATED_IN_SINKING_AND_SLIDING_AREA")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={sliding.code === 'YES'}
                onChange={(e) => setSliding(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {sliding.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="sliding.name"
              value={sliding.name}
              onChange={(e) => setSliding(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

          <FormControlLabel
            label={t("BPA_APPLICATION_RAINWATER_HARVESTING_TANK_PROVISION")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={rainwater.code === 'YES'}
                onChange={(e) => setRainwater(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {rainwater.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="rainwater.name"
              value={rainwater.name}
              onChange={(e) => setRainwater(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

        <CardLabel style={cardLabelStyle}>{`${t("BPA_APPLICATION_NO_OF_DWELLING_UNIT")}`}</CardLabel>
            <TextInput
              t={t}
              type={"number"}
              isMandatory={false}
              optionKey="i18nKey"
              name="dwelling"
              value={dwelling}
              onChange={(e) => setDwelling(e.target.value)}
              {...(validation = {
                isRequired: true,
                pattern: "^[0-9]*$",
                type: "number",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />

          {isUdFlow && <React.Fragment>
            <CardLabel style={cardLabelStyle}>{`${t("BPA_CHECKLIST_OPTION_MUCK_TO_BE_DISPOSED")}`}</CardLabel>
            <TextInput
              t={t}
              type={"number"}
              isMandatory={false}
              optionKey="i18nKey"
              name="muckToBeDisposed"
              value={muckToBeDisposed}
              onChange={(e) => setMuckToBeDisposed(e.target.value)}
              {...(validation = {
                isRequired: true,
                pattern: "^[0-9]*$",
                type: "number",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          </React.Fragment>}

          <FormControlLabel
            label={t("BPA_APPLICATION_WHEATHER_THE_PERMISSION_FROM_AIRPORT_AUTHORITY_OF_INDIA_IS_REQUIRED")}
            sx={{ display: 'block' }}
            control={
              <Checkbox
                sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                checked={airport.code === 'YES'}
                onChange={(e) => setAirport(value => ({ ...value, code: e.target.checked ? "YES" : "NO" }))}
              />
            }
          />
          {airport.code === 'YES' && (
            <TextInput
              t={t}
              type={"text"}
              isMandatory={false}
              optionKey="i18nKey"
              name="airport.name"
              value={airport.name}
              onChange={(e) => setAirport(value => ({ ...value, name: e.target.value }))}
              {...(validation = {
                isRequired: true,
                pattern: "^[a-zA-Z-.`' ]*$",
                type: "text",
                title: t("PT_NAME_ERROR_MESSAGE"),
              })}
            />
          )}

            </div>
            <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={goNext} style={{margin: '1rem'}} />
      </FormStep>
      {showToast && <Toast error={true} label={t(showToast?.message)} isDleteBtn={true} onClose={closeToast} />}
    </React.Fragment>
  );
};

export default ScrutinyDetails;
